<div class="header-helper">
  This page details the authorizers and thresholds to manage the domain. There are four change
  request types: change of control requests such as a domain transfer or revocation; non-technical root
  zone change requests such as contacts; technical root zone change requests such as name servers
  and trust anchors; and authorization policy change requests. Click “Update” in the section you want
  to update. Before final submission, you will be asked to review and confirm your changes.
</div>
<div class="content content-with-elevation">
  <auth-policy-view *ngIf="!editMode" [lastchange]="lastchange" [authPolicy]="domain?.authPolicy" (edit)="edit($event)" [pendingRequestChangeID]="pendingRequestChangeID" [viewMode]="viewMode" [usersChange]="authPolicyUsersChange" [authPolicyChange]="authPolicyChange"></auth-policy-view>
  <auth-policy-edit *ngIf="editMode" [authPolicy]="domain?.authPolicy" (cancelOutPut)="cancel($event)" (authPolicyVOOutput)="authPolicyVOOutput($event)"></auth-policy-edit>
</div>

